import type { DefaultFallback, FlattenedCommand } from '../../types/commands/index.tsx';
import type { ResultUseMatches } from '../../types/use-matches/index.tsx';

export const getFallbackCommandResult = (
	fallback: DefaultFallback | undefined,
): ResultUseMatches | undefined => {
	if (!fallback || !fallback?.onNoResults?.fallbackCommand) {
		return undefined;
	}
	const { fallbackCommand, fallbackSection } = fallback.onNoResults;

	const section = fallbackSection;

	const fallbackCommandHeader =
		fallbackCommand && section
			? {
					...(section.renderName
						? {
								renderGroup: section.renderName,
							}
						: {
								group: section.name,
							}),

					isGroup: true,
				}
			: undefined;

	return {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		results: [fallbackCommandHeader, { command: fallbackCommand, active: true, index: 0 }].filter(
			Boolean,
		) as FlattenedCommand[],
		total: 1,
		activeCommand: fallbackCommand,
		fallback,
	};
};
